import type { ReactElement } from 'react';

import { nextProjectUrl } from '@shared/constants/urls';

import { addDefaultUtmParams } from '@msq/components/pages/HomePageV2/utils/addDefaultUtmParams';
import { Chest } from '@ui/uikit/components/icons/mono/Chest';
import { Fire } from '@ui/uikit/components/icons/mono/Fire';
import Gem from '@ui/uikit/components/icons/mono/Gem';
import { Karma } from '@ui/uikit/components/icons/mono/Karma';
import { Leave } from '@ui/uikit/components/icons/mono/Leave';
import { Prediction } from '@ui/uikit/components/icons/mono/Prediction';
import { Ticket } from '@ui/uikit/components/icons/mono/Ticket';
import { MagicsquareLogo } from '@ui/uikit/components/logos/MagicsquareLogo';

export interface DiscoverEngageEarnConfigItem {
  id: string;
  title: string;
  description: string;
  href: string;
  icon: ReactElement;
  buttonLabel: string;
  iconColor?: string;
  iconBackgroundColor: string;
  isAuthRequired?: boolean;
}

export const discoverEngageEarnConfig: DiscoverEngageEarnConfigItem[] = [
  {
    id: 'magicStore',
    title: 'Magic Store',
    description:
      'Browse 2,500+ dApps and games across DeFi, GameFi, Telegram Mini-Apps, AI Agents, Meme Tokens, and more.',
    href: addDefaultUtmParams(nextProjectUrl.store('/')),
    icon: <MagicsquareLogo />,
    buttonLabel: 'View Store',
    iconBackgroundColor:
      'linear-gradient(194.51deg, rgba(255, 128, 102, 0.15) 5.14%, rgba(230, 102, 255, 0.15) 47.43%, rgba(102, 179, 255, 0.15) 89.72%)',
  },
  {
    id: 'hotOffers',
    title: 'Hot Offers',
    description: 'Join project campaigns, complete tasks, and earn token rewards.',
    href: addDefaultUtmParams(nextProjectUrl.store('/hot-offers')),
    icon: <Fire />,
    buttonLabel: 'View Offers',
    iconColor: 'var(--text-color-red)',
    iconBackgroundColor: 'var(--bg-secondary-red)',
  },
  {
    id: 'rewardPools',
    title: 'Reward Pools',
    description: 'Your activity and engagement gives you access to daily rewards.',
    href: addDefaultUtmParams(nextProjectUrl.store('/reward-pools')),
    icon: <Chest />,
    buttonLabel: 'View Pools',
    iconColor: 'var(--text-color-orange)',
    iconBackgroundColor: 'var(--bg-secondary-orange)',
  },
  {
    id: 'magicKarma',
    title: 'Magic Karma',
    description: 'Your on-chain and off-chain Magic Square reputation system.',
    href: addDefaultUtmParams(nextProjectUrl.store('/profile/karma')),
    icon: <Karma />,
    buttonLabel: 'About Karma',
    iconColor: 'var(--text-color-pink)',
    iconBackgroundColor: 'var(--bg-secondary-pink)',
    isAuthRequired: true,
  },
  {
    id: 'magicRaffles',
    title: 'Magic Raffles',
    description:
      'Buy tickets using USDT or SQR for a chance to win massive rewards in our high-stakes, community-powered raffles.',
    href: addDefaultUtmParams(nextProjectUrl.store('/magic-raffles')),
    icon: <Ticket />,
    buttonLabel: 'View Raffles',
    iconColor: 'var(--text-color-green)',
    iconBackgroundColor: 'var(--bg-secondary-green)',
  },
  {
    id: 'magicPredictions',
    title: 'Magic Predictions',
    description: 'Predict market moves and win crypto rewards.',
    href: addDefaultUtmParams(nextProjectUrl.store('/magic-predictions')),
    icon: <Prediction />,
    buttonLabel: 'View Predictions',
    iconColor: 'var(--text-color-purple)',
    iconBackgroundColor: 'var(--bg-secondary-purple)',
  },
  {
    id: 'magicBoard',
    title: 'Magic Board',
    description:
      'Complete tasks across the Magic Square ecosystem to earn exclusive benefits and rewards.',
    href: addDefaultUtmParams(nextProjectUrl.store('/magic-board')),
    icon: <Gem />,
    buttonLabel: 'View Quests',
    iconColor: 'var(--text-color-blue)',
    iconBackgroundColor: 'var(--bg-secondary-blue)',
  },
  {
    id: 'magicFarms',
    title: 'Magic Farms',
    description:
      'Stake tokens across multiple projects and earn rewards through a flexible and fair system.',
    href: addDefaultUtmParams(nextProjectUrl.staking('/farms')),
    icon: <Leave />,
    buttonLabel: 'View Farms',
    iconColor: 'var(--text-color-green)',
    iconBackgroundColor: 'var(--bg-secondary-green)',
  },
];
